import { is, isLike, isNull } from "ts-type-guards";
export var Status;
(function (Status) {
    Status["OK"] = "OK";
    Status["ABSENT"] = "ABSENT";
    Status["TYPE_ERROR"] = "TYPE_ERROR";
    Status["JSON_ERROR"] = "JSON_ERROR";
    Status["STORAGE_ERROR"] = "STORAGE_ERROR";
    Status["NUMBER_ERROR"] = "NUMBER_ERROR";
})(Status || (Status = {}));
const LOCAL_STORAGE = () => localStorage;
const SESSION_STORAGE = () => sessionStorage;
export function get(key, fallback) {
    return getFrom(LOCAL_STORAGE, key, fallback);
}
export function get_session(key, fallback) {
    return getFrom(SESSION_STORAGE, key, fallback);
}
export function set(key, value) {
    return setIn(LOCAL_STORAGE, key, value);
}
export function set_session(key, value) {
    return setIn(SESSION_STORAGE, key, value);
}
export function remove(key) {
    return removeIn(LOCAL_STORAGE, key);
}
export function remove_session(key) {
    return removeIn(SESSION_STORAGE, key);
}
function getFrom(storage, key, fallback) {
    try {
        const savedValue = readFrom(storage(), key, fallback);
        if (isNull(savedValue)) {
            return {
                status: "ABSENT",
                value: fallback,
            };
        }
        else {
            return {
                status: "OK",
                value: savedValue,
            };
        }
    }
    catch (err) {
        const status = (is(SyntaxError)(err) ? "JSON_ERROR"
            :
                is(TypeError)(err) ? "TYPE_ERROR"
                    :
                        "STORAGE_ERROR");
        return {
            status,
            value: fallback,
        };
    }
}
function setIn(storage, key, value) {
    try {
        saveIn(storage(), key, value);
        return {
            status: "OK",
            value,
        };
    }
    catch (err) {
        const status = (is(RangeError)(err) ? "NUMBER_ERROR"
            :
                is(SyntaxError)(err) || is(TypeError)(err) ? "JSON_ERROR"
                    :
                        "STORAGE_ERROR");
        return {
            status,
            value,
        };
    }
}
function removeIn(storage, key) {
    try {
        storage().removeItem(key);
        return {
            status: "OK",
            value: true,
        };
    }
    catch (err) {
        return {
            status: "STORAGE_ERROR",
            value: false,
        };
    }
}
function readFrom(storage, key, reference) {
    if (storage === null) {
        throw new DOMException();
    }
    const readValue = storage.getItem(key);
    if (isNull(readValue)) {
        return null;
    }
    const parsedValue = JSON.parse(readValue);
    if (isLike(reference)(parsedValue)) {
        return parsedValue;
    }
    throw new TypeError(`Saved value had wrong type.`);
}
function saveIn(storage, key, value) {
    const replacer = (_key, v) => {
        if (typeof v === "number" && !Number.isFinite(v)) {
            throw new RangeError(v.toString());
        }
        return v;
    };
    const stringifiedValue = JSON.stringify(value, replacer);
    if (storage === null) {
        throw new DOMException();
    }
    storage.setItem(key, stringifiedValue);
}
//# sourceMappingURL=index.js.map